module.exports = __webpack_public_path__ + "static/media/personaje.3f3a61d5.png";